import { Options, Vue } from 'vue-class-component';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { Language } from '@/i18n';
import store from '@/store';
import { getLanguage } from '@/shared/utils';
import { Inject, Watch } from 'vue-property-decorator';
import UserService from '@/services/user.service';

@Options({
  props: {
    text: String,
  },
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
  },
})
export default class LanguageDropdown extends Vue {
  currentLanguage: Language | null = null;
  @Inject('userService')
  public userService!: UserService;

  @Watch('$store.state.currentLocale.locale', { deep: true })
  async refreshUserForLocaleChange() {
    if (store.state.user?.userId) {
      return this.userService.account(false, true);
    }
  }

  beforeMount(): void {
    const currentLanguage = getLanguage(localStorage.language);
    this.currentLanguage = currentLanguage;
  }

  changeLanguage(lang: string): void {
    this.$i18n.locale = lang;
    localStorage.language = lang;
    this.currentLanguage = getLanguage(lang);
    store.commit('currentLocale', this.currentLanguage);
  }
}
